/**
 * UI Constants
 * Centralized configuration for UI elements, colors, and sizing
 */

/**
 * Avatar size configurations
 */
export const AVATAR_SIZES = {
  SMALL: 24,
  MEDIUM: 32,
  LARGE: 40,
  XLARGE: 56,
} as const;

/**
 * Consistent avatar colors for user representation
 * These colors are used for generating consistent user avatars
 */
export const AVATAR_COLORS = [
  '#1976d2', // Primary blue
  '#388e3c', // Green
  '#d32f2f', // Red
  '#f57c00', // Orange
  '#7b1fa2', // Purple
  '#0288d1', // Light blue
  '#c2185b', // Pink
  '#00796b', // Teal
  '#5d4037', // Brown
  '#455a64', // Blue grey
] as const;

/**
 * Provider-specific colors for authentication providers
 */
export const PROVIDER_COLORS = {
  LOCAL: '#1976d2', // Primary blue
  ENTRA: '#0078d4', // Microsoft blue
  GOOGLE: '#4285f4', // Google blue
  OKTA: '#007dc1', // Okta blue
  DEFAULT: '#757575', // Grey
} as const;

/**
 * Sidebar and drawer widths
 */
export const DRAWER_WIDTHS = {
  MAIN_MENU: 240,
  MAIN_MENU_COLLAPSED: 64,
  CONVERSATION_SIDEBAR: 280,
  DOCUMENT_REFERENCES: 350,
} as const;

/**
 * Breakpoints for responsive design (matches MUI defaults)
 */
export const BREAKPOINTS = {
  XS: 0,
  SM: 600,
  MD: 900,
  LG: 1200,
  XL: 1536,
} as const;

/**
 * Z-index layering for UI elements
 */
export const Z_INDEX = {
  DRAWER: 1200,
  APP_BAR: 1100,
  MODAL: 1300,
  SNACKBAR: 1400,
  TOOLTIP: 1500,
} as const;

/**
 * Animation durations (milliseconds)
 */
export const ANIMATION_DURATION = {
  FAST: 200,
  NORMAL: 300,
  SLOW: 500,
} as const;

/**
 * Debounce and throttle delays (milliseconds)
 */
export const TIMING = {
  DEBOUNCE_SEARCH: 300,
  DEBOUNCE_INPUT: 500,
  THROTTLE_SCROLL: 100,
  THROTTLE_RESIZE: 200,
} as const;
